import React from 'react'
import { useFileUpload } from './provider'
import Typography from 'APP/Converse/Typography'
import styled from 'styled-components/native'

const Container = styled.View`
  padding: 4px 0;
`

export const FileUploadError = () => {
  const { errorMessage, isError } = useFileUpload()

  return (
    <Container>
      <Typography variant="bodySmall" color="error">
        {isError && errorMessage}
      </Typography>
    </Container>
  )
}
